function initBundleCardSliders(root = document) {
  root.querySelectorAll('[data-bundle-card-slider]').forEach((slider) => {
    if (slider.swiper || slider.dataset.sliderInitialized === 'true') return;

    const controls = slider.nextElementSibling;
    const slideCount = slider.querySelectorAll('.swiper-slide').length;

    if (slideCount < 2) {
      controls?.classList.add('is-single-slide');
      slider.dataset.sliderInitialized = 'true';
      return;
    }

    if (typeof window.Swiper === 'undefined') return;
    if (!controls?.classList.contains('bundle-showcase__gallery-controls')) return;

    new window.Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 350,
      autoHeight: false,
      observer: true,
      observeParents: true,
      watchOverflow: true,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      pagination: {
        el: controls.querySelector('.bundle-showcase__gallery-pagination'),
        clickable: true,
      },
      navigation: {
        prevEl: controls.querySelector('.bundle-showcase__gallery-prev'),
        nextEl: controls.querySelector('.bundle-showcase__gallery-next'),
      },
    });

    slider.dataset.sliderInitialized = 'true';
  });
}

function startBundleCardSliders(root = document, attempts = 20) {
  if (typeof window.Swiper !== 'undefined') {
    initBundleCardSliders(root);
    return;
  }

  if (attempts > 0) {
    window.setTimeout(() => startBundleCardSliders(root, attempts - 1), 100);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => startBundleCardSliders());
} else {
  startBundleCardSliders();
}

document.addEventListener('shopify:section:load', (event) => {
  startBundleCardSliders(event.target);
});
